import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal, ButtonToolbar } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  checkPermision,
  dateDefault,
  formLabelsTheme,
  getValueType,
  iconError,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  useForceUpdate,
} from "../../utility";
import SVG from "react-inlinesvg";
import Select from "react-select";
import {
  sortCaret,
  headerSortingClasses,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";
import {
  selectPagination,
  selectUser,
} from "../../modules/Auth/_redux/authRedux";

// MUI
import {
  fade,
  withStyles,
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { red } from "@material-ui/core/colors";
// import { UserCreate } from "./UserCreate";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { FormHelperText } from "@material-ui/core";
import { addInbound, selectLoading } from "./inboundSlice";
import { Autocomplete } from "@material-ui/lab";
import {
  fetchParameter,
  fetchParameter2,
  fetchParameter3,
  fetchParameter4,
  selectParameter,
  selectParameter2,
  selectParameter3,
  selectParameter4,
} from "../businessParameter/businessParameterSlice";
import { ModalClientRadio } from "./ModalClientRadio";
import { ModalLocationMasterRadio } from "./ModalLocationMasterRadio";
import { ModalPartyRadio } from "./ModalPartyRadio";
import { fetchClient } from "../client/clientSlice";
import { fetchParty } from "../party/partySlice";
import { fetchLocationMaster } from "../location/locationSlice";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
    "& .MuiInputLabel-filled": {
      transform: "translate(12px, 10px) scale(0.75)",
      // transition: theme.transitions.create(["transform", "color"]),
      // color: theme.palette.text.primary,
      fontSize: "12px",
    },
  },
  focused: {},
  inputLabelRoot: {
    transform: "translate(12px, 10px) scale(1)",
    fontSize: "12px",
  },
}));

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const InboundCreate = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataService = useSelector(selectParameter);
  const dataJobType = useSelector(selectParameter2);
  const dataInbound = useSelector(selectParameter3);
  const dataOutbound = useSelector(selectParameter4);

  const forceUpdate = useForceUpdate();

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      await dispatch(
        fetchParameter({
          paramgroup_code: "SERVICE_CLASS",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter2({
          paramgroup_code: "JOB_TYPE",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter3({
          paramgroup_code: "INBOUND_DOM",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter4({
          paramgroup_code: "OUTBOUND_DOM",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchClient({
          is_enable: "Y",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchClient({
          is_enable: "Y",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParty({
          party_setting: "SHIPPER",
          is_enable: "Y",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchLocationMaster({
          locationmaster_type: "SEA_PORT",
          is_enable: "Y",
          pageNo: 1,
          pageSize: -1,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  const [formValues, setFormValues] = useState({
    client: {
      value: "",
      error: false,
      required: "Y",
    },
    client_name: {
      value: "",
      error: false,
      required: "Y",
    },
    job_date: {
      value: dateDefault,
      error: false,
      required: "Y",
    },
    estimate_delivery: {
      value: dateDefault,
      error: false,
      required: "N",
    },

    port_of_loading: {
      value: "",
      error: false,
      required: "N",
    },

    port_of_loading_name: {
      value: "",
      error: false,
      required: "N",
    },
    shipper: {
      value: "",
      error: false,
      required: "N",
    },
    shipper_name: {
      value: "",
      error: false,
      required: "N",
    },
    job_type: {
      value: "",
      error: false,
      required: "Y",
    },
    estimate_arrival: {
      value: dateDefault,
      error: false,
      required: "N",
    },
    service_class: {
      value: "",
      error: false,
      required: "Y",
    },
    port_of_discharge: {
      value: "",
      error: false,
      required: "N",
    },
    port_of_discharge_name: {
      value: "",
      error: false,
      required: "N",
    },
    inbound: {
      value: "",
      error: false,
      required: "N",
    },
    outbound: {
      value: "",
      error: false,
      required: "N",
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);

    console.log(isValid, "isValid");
    return isValid;
  };

  const handleSave = async () => {
    if (!validatePost()) {
      return;
    }

    const params = {
      client: formValues.client.value,
      shipper: formValues.shipper.value,
      job_date: formValues.job_date.value,
      job_type: formValues.job_type.value,
      estimated_delivery: formValues.estimate_delivery.value,
      estimated_arrive: formValues.estimate_arrival.value,
      // actual_delivery: formValues.actual_delivery.value,
      // actual_arrive: formValues.actual_arrive.value,
      port_of_loading: formValues.port_of_loading.value,
      port_of_discharge: formValues.port_of_discharge.value,
      services_class: formValues.service_class.value,
      inbound: formValues.inbound.value,
      outbound: formValues.outbound.value,
    };

    try {
      const response = await dispatch(addInbound(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        if (action.isConfirmed)
          history.push(
            `/inbound/edit/${response.payload.data.data.inbound_id}`
          );
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const serviceOptions = dataService.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const jobTypeOptions = dataJobType.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const inboundOptions = dataInbound.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const outboundOptions = dataOutbound.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const handleChangeService = (e, params) => {
    const value = params.value;
    setFormValues({
      ...formValues,
      ["service_class"]: {
        ...formValues["service_class"],
        value,
      },
    });
  };

  const handleChangeJobType = (e, params) => {
    const value = params.value;
    setFormValues({
      ...formValues,
      ["job_type"]: {
        ...formValues["job_type"],
        value,
      },
    });
  };

  const handleChangeInbound = (e, params) => {
    if (params === null) {
      setFormValues({
        ...formValues,
        ["inbound"]: {
          ...formValues["inbound"],
          value: "",
        },
      });
    } else {
      setFormValues({
        ...formValues,
        ["inbound"]: {
          ...formValues["inbound"],
          value: params.value,
        },
      });
    }
  };

  const handleChangeOutbound = (e, params) => {
    if (params === null) {
      setFormValues({
        ...formValues,
        ["outbound"]: {
          ...formValues["outbound"],
          value: "",
        },
      });
    } else {
      setFormValues({
        ...formValues,
        ["outbound"]: {
          ...formValues["outbound"],
          value: params.value,
        },
      });
    }
  };

  const index = serviceOptions.findIndex(
    (obj) => obj.value === formValues.service_class.value
  );

  const indexJobType = jobTypeOptions.findIndex(
    (obj) => obj.value === formValues.job_type.value
  );

  const indexOutbound = outboundOptions.findIndex(
    (obj) => obj.value === formValues.outbound.value
  );
  const indexInbound = inboundOptions.findIndex(
    (obj) => obj.value === formValues.inbound.value
  );

  // modal

  const [showClient, setShowClient] = useState(false);
  const [showLocationMaster, setShowLocationMaster] = useState(false);
  const [showShipper, setShowShipper] = useState(false);

  const [typeLocation, setTypeLocation] = useState("");

  const [fields, setFields] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <div>
        <Card>
          <CardBody>
            <ThemeProvider theme={formLabelsTheme}>
              {/* Basic Detail */}
              <div>
                <Row>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          required
                          label="Client"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          value={formValues.client_name.value}
                          readOnly
                          error={formValues.client.error}
                          helperText={
                            formValues.client.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                      </Col>
                      <Col xs={1} sm={1} md={1} lg={1}>
                        <div>
                          <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                            <span
                              className="svg-icon svg-icon-md svg-icon-light"
                              onClick={() => {
                                setShowClient(true);
                              }}
                            >
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/Search.svg"
                                )}
                              />
                            </span>
                          </a>
                        </div>
                      </Col>
                      {formValues.client_name.value !== "" && (
                        <Col xs={1} sm={1} md={1} lg={1}>
                          <div
                            style={{ marginTop: "22px", cursor: "pointer" }}
                            onClick={() => {
                              setFormValues({
                                ...formValues,
                                ["client"]: {
                                  ...formValues["client"],
                                  value: "",
                                },
                                ["client_name"]: {
                                  ...formValues["client_name"],
                                  value: "",
                                },
                              });
                            }}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/x-square.svg"
                                )}
                              />
                            </span>
                          </div>
                        </Col>
                      )}
                    </Row>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          required
                          label="Job Date"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          type="date"
                          size="small"
                          fullWidth
                          name="job_date"
                          value={formValues.job_date.value}
                          onChange={handleChange}
                          error={formValues.job_date.error}
                          helperText={
                            formValues.job_date.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <Autocomplete
                          disablePortal
                          name="inbound"
                          options={inboundOptions}
                          getOptionLabel={(option) => option.label.toString()}
                          // disableClearable={true}
                          onChange={handleChangeInbound}
                          value={inboundOptions[indexInbound]}
                          renderInput={(params) => (
                            <RedditTextField
                              className={classes.margin}
                              {...params}
                              label="Inbound"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              placeholder="Select"
                              name="inbound"
                            />
                          )}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <Autocomplete
                          disablePortal
                          name="outbound"
                          options={outboundOptions}
                          getOptionLabel={(option) => option.label.toString()}
                          // disableClearable={false}
                          onChange={handleChangeOutbound}
                          value={outboundOptions[indexOutbound]}
                          renderInput={(params) => (
                            <RedditTextField
                              className={classes.margin}
                              {...params}
                              label="Outbound"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              placeholder="Select"
                              name="outbound"
                            />
                          )}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          label="Estimated Time of Delivery"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          fullWidth
                          size="small"
                          type="date"
                          name="estimate_delivery"
                          value={formValues.estimate_delivery.value}
                          onChange={handleChange}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          label="Port of Loading"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          value={formValues.port_of_loading_name.value}
                          readOnly
                        />
                      </Col>
                      <Col xs={1} sm={1} md={1} lg={1}>
                        <div>
                          <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                            <span
                              className="svg-icon svg-icon-md svg-icon-light"
                              onClick={() => {
                                setTypeLocation("loading");

                                setShowLocationMaster(true);
                              }}
                            >
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/Search.svg"
                                )}
                              />
                            </span>
                          </a>
                        </div>
                      </Col>
                      {formValues.port_of_loading_name.value !== "" && (
                        <Col xs={1} sm={1} md={1} lg={1}>
                          <div
                            style={{ marginTop: "22px", cursor: "pointer" }}
                            onClick={() => {
                              setFormValues({
                                ...formValues,
                                ["port_of_loading"]: {
                                  ...formValues["port_of_loading"],
                                  value: "",
                                },
                                ["port_of_loading_name"]: {
                                  ...formValues["port_of_loading_name"],
                                  value: "",
                                },
                              });
                            }}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/x-square.svg"
                                )}
                              />
                            </span>
                          </div>
                        </Col>
                      )}
                    </Row>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          label="Port of Discharge"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          value={formValues.port_of_discharge_name.value}
                          readOnly
                        />
                      </Col>
                      <Col xs={1} sm={1} md={1} lg={1}>
                        <div>
                          <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                            <span
                              className="svg-icon svg-icon-md svg-icon-light"
                              onClick={() => {
                                setTypeLocation("discharge");
                                setShowLocationMaster(true);
                              }}
                            >
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/Search.svg"
                                )}
                              />
                            </span>
                          </a>
                        </div>
                      </Col>
                      {formValues.port_of_discharge_name.value !== "" && (
                        <Col xs={1} sm={1} md={1} lg={1}>
                          <div
                            style={{ marginTop: "22px", cursor: "pointer" }}
                            onClick={() => {
                              setFormValues({
                                ...formValues,
                                ["port_of_discharge"]: {
                                  ...formValues["port_of_discharge"],
                                  value: "",
                                },
                                ["port_of_discharge_name"]: {
                                  ...formValues["port_of_discharge_name"],
                                  value: "",
                                },
                              });
                            }}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/x-square.svg"
                                )}
                              />
                            </span>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </Col>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          label="Shipper"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          value={formValues.shipper_name.value}
                          readOnly
                        />
                      </Col>
                      <Col xs={1} sm={1} md={1} lg={1}>
                        <div>
                          <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                            <span
                              className="svg-icon svg-icon-md svg-icon-light"
                              onClick={() => {
                                setShowShipper(true);
                              }}
                            >
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/Search.svg"
                                )}
                              />
                            </span>
                          </a>
                        </div>
                      </Col>
                      {formValues.shipper_name.value !== "" && (
                        <Col xs={1} sm={1} md={1} lg={1}>
                          <div
                            style={{ marginTop: "22px", cursor: "pointer" }}
                            onClick={() => {
                              setFormValues({
                                ...formValues,
                                ["shipper"]: {
                                  ...formValues["shipper"],
                                  value: "",
                                },
                                ["shipper_name"]: {
                                  ...formValues["shipper_name"],
                                  value: "",
                                },
                              });
                            }}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/x-square.svg"
                                )}
                              />
                            </span>
                          </div>
                        </Col>
                      )}
                    </Row>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <Autocomplete
                          disablePortal
                          name="job_type"
                          options={jobTypeOptions}
                          getOptionLabel={(option) => option.label.toString()}
                          disableClearable={true}
                          onChange={handleChangeJobType}
                          value={jobTypeOptions[indexJobType]}
                          renderInput={(params) => (
                            <RedditTextField
                              required
                              className={classes.margin}
                              {...params}
                              label="Job Type"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              placeholder="Select"
                              name="job_type"
                              error={formValues.job_type.error}
                              helperText={
                                formValues.job_type.error ? (
                                  <FormHelperText
                                    sx={{ mt: "5px", mb: "-10px" }}
                                  >
                                    {iconError} {"This field is required"}
                                  </FormHelperText>
                                ) : (
                                  ""
                                )
                              }
                            />
                          )}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          label="Estimated Time of Arrival"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          fullWidth
                          size="small"
                          type="date"
                          name="estimate_arrival"
                          value={formValues.estimate_arrival.value}
                          onChange={handleChange}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <Autocomplete
                          disablePortal
                          name="service_class"
                          options={serviceOptions}
                          getOptionLabel={(option) => option.label.toString()}
                          disableClearable={true}
                          onChange={handleChangeService}
                          value={serviceOptions[index]}
                          renderInput={(params) => (
                            <RedditTextField
                              required
                              className={classes.margin}
                              {...params}
                              label="Service Class"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              placeholder="Select"
                              name="service_class"
                              error={formValues.service_class.error}
                              helperText={
                                formValues.service_class.error ? (
                                  <FormHelperText
                                    sx={{ mt: "5px", mb: "-10px" }}
                                  >
                                    {iconError} {"This field is required"}
                                  </FormHelperText>
                                ) : (
                                  ""
                                )
                              }
                            />
                          )}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {/* handleSave */}
                <Row className="mt-6 justify-content-end">
                  <Button variant="primary" onClick={handleSave}>
                    Save
                  </Button>
                </Row>
              </div>
            </ThemeProvider>
          </CardBody>
        </Card>

        {/* Modal Create */}

        <ModalClientRadio
          isOpen={showClient}
          setShow={setShowClient}
          setFormValues={setFormValues}
          formValues={formValues}
          setFields={setFields}
          fields={fields}
        />
        <ModalLocationMasterRadio
          isOpen={showLocationMaster}
          setShow={setShowLocationMaster}
          setFormValues={setFormValues}
          formValues={formValues}
          setFields={setFields}
          fields={fields}
          typeLocation={typeLocation}
          setTypeLocation={setTypeLocation}
        />

        <ModalPartyRadio
          isOpen={showShipper}
          setShow={setShowShipper}
          setFormValues={setFormValues}
          formValues={formValues}
          setFields={setFields}
          fields={fields}
        />
      </div>
    </>
  );
};
